var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-screen"},[_c('img',{class:{'pb-6 pl-4': !_vm.$saas.main},attrs:{"alt":_vm.$saas.name,"src":_vm.logo}}),_c('LLoading',{attrs:{"is-full-page":false,"active":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }